module.exports = __webpack_public_path__ + "media/customizations/wonderlandbyrunway/back-80209faf9b0747da86f715a3a48ff82f.jpg";